module.exports = __webpack_public_path__ + "static/atlaskit-avatar-status-1393a7966c8d7ed4ea0abf4b4f911cb7.png";